/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGraduationHat = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 2.856 23.06 9l-.06.033V16h-2v-5.856l-2 1.111v6.363l-7 3.5-7-3.5v-6.363L.94 9zm-5 9.51v4.016l5 2.5 5-2.5v-4.016l-5 2.778zM5.06 9 12 12.856 18.94 9 12 5.144zM13 10h-2V8h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgGraduationHat as GraduationHat };
